export default __webpack_public_path__ + "static/media/1009.1661ee6c.png";